import { graphql, useStaticQuery } from "gatsby"

export const useFilterData = () => {
  const {
    allContentfulCategory: { nodes: allCategory },
    allContentfulTopic: { nodes: allTopic },
    allContentfulLevel: { nodes: allLevel },
  } = useStaticQuery(
    graphql`
      {
        allContentfulTopic(sort: { fields: order, order: ASC }) {
          nodes {
            name
            id
            contentful_id
          }
        }
        allContentfulLevel(sort: { fields: order, order: ASC }) {
          nodes {
            name
            id
            contentful_id
          }
        }
        allContentfulCategory(sort: { fields: order, order: ASC }) {
          nodes {
            name
            id
            contentful_id
          }
        }
      }
    `
  )

  const topicDict = allTopic.reduce((prev, { name, contentful_id }) => {
    prev[name] = contentful_id
    return prev
  }, {})

  const levelDict = allLevel.reduce((prev, { name, contentful_id }) => {
    prev[name] = contentful_id
    return prev
  }, {})

  const categoryDict = allCategory.reduce((prev, { name, contentful_id }) => {
    prev[name] = contentful_id
    return prev
  }, {})

  return { allCategory, allTopic, allLevel, topicDict, levelDict, categoryDict }
}
